module.exports = "https://cdn.thelire.com/ins/resource/pic_popup_profileinfoincomplete.4db141fdc730ed3e0fa3828ad31953b1.png";